import { bool, object, string } from 'yup'



export const TaxIdRegex = /^(?:\d{10}|\d{3}-\d{3}-\d{2}-\d{2})$/
export const PostalCodeRegex = /^\d{2}-\d{3}$/
export const PhoneNumberRegex =
  /^(?!.*(\d)\1{6,})(?!123456789)(?!987654321)\d{9}$/
export const FloorNumberRegex = /^-?\d+$/

//regexp used in validation for email for registration
export const emailRegistrationRegex = /^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/i

//intententionally added possible character + to emailRegex
export const emailRegex = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,}$/i

// NEWSLETTER SIGNUP FORM VALIDATION
export const newsletterSchema = object().shape({
  email: string()
    .required('Email jest wymagany')
    .matches(emailRegex, 'Niepoprawny adres email')
    .email('Niepoprawny adres email'),
  newsletterAgreement: bool().oneOf([true], 'Zgoda jest wymagana')
})

type PasswordRuleKey =
  | 'length'
  | 'lowercase'
  | 'uppercase'
  | 'number'
  | 'special'

// Single source of rules for PasswordHint, the PasswordField screen reader description and passwordRegex
export const PASSWORD_RULES = [
  { key: 'length', label: 'Min. 8 znaków', pattern: /(?=.{8,})/ },
  { key: 'number', label: 'Min. 1 cyfra', pattern: /(?=.*[0-9])/ },
  { key: 'lowercase', label: 'Min. 1 mała litera', pattern: /(?=.*[a-z])/ },
  {
    key: 'special',
    label: 'Min. 1 znak specjalny',
    pattern: /(?=.*[!@#$%^&*()_\-+='";:<,>.?/{}[\]`~\\|])/
  },
  { key: 'uppercase', label: 'Min. 1 wielka litera', pattern: /(?=.*[A-Z])/ }
] as const satisfies ReadonlyArray<{
  key: PasswordRuleKey
  label: string
  pattern: RegExp
}>

export const passwordRegex = new RegExp(
  `^${PASSWORD_RULES.map(({ pattern }) => pattern.source).join('')}`
)

export const validateNip = (nip: string) => {
  const nipWithoutDashes = nip.replace(/-/g, '')
  const reg = /^[0-9]{10}$/

  if (!reg.test(nipWithoutDashes)) {
    return false
  } else {
    const digits = ('' + nipWithoutDashes).split('')
    const checksum =
      (6 * parseInt(digits[0]) +
        5 * parseInt(digits[1]) +
        7 * parseInt(digits[2]) +
        2 * parseInt(digits[3]) +
        3 * parseInt(digits[4]) +
        4 * parseInt(digits[5]) +
        5 * parseInt(digits[6]) +
        6 * parseInt(digits[7]) +
        7 * parseInt(digits[8])) %
      11

    return parseInt(digits[9]) === checksum
  }
}
